document.addEventListener('DOMContentLoaded', () => {
  const announcementBar = document.querySelector('.custom-announcement-bar');
  if (!announcementBar) return;

  const slides          = announcementBar.querySelectorAll('.custom-announcement-bar__slide');
  // The play/pause toggle button is currently commented out in the section,
  // so this is usually null. Everything below treats it as OPTIONAL — the
  // previous version crashed here (toggleButton.addEventListener on null),
  // which is why the bar never actually rotated.
  const toggleButton    = announcementBar.querySelector('.custom-announcement-bar__toggle');
  const anounce_normal  = announcementBar.querySelectorAll('.custom-anouncement-normal');
  const anounce_special = announcementBar.querySelectorAll('.custom-anouncement-special');

  // US visitors see the "special" copy (text_special), everyone else the
  // normal copy (text). Default to normal if geo lookup fails.
  fetch('https://ipapi.co/json/')
    .then((response) => response.json())
    .then((data) => {
      const isUS = data && data.country_code === 'US';
      anounce_normal.forEach((el) => (el.style.display = isUS ? 'none' : 'block'));
      anounce_special.forEach((el) => (el.style.display = isUS ? 'block' : 'none'));
    })
    .catch(() => {
      anounce_normal.forEach((el) => (el.style.display = 'block'));
      anounce_special.forEach((el) => (el.style.display = 'none'));
    });

  let currentIndex = 0;
  let interval = null;
  let isPlaying = true;

  // Show only the first slide initially; the rest fade in on rotation.
  slides.forEach((slide, i) => slide.classList.toggle('active', i === 0));

  const nextSlide = () => {
    if (slides.length <= 1) return;
    const oldIndex = currentIndex;
    const newIndex = (currentIndex + 1) % slides.length;
    // Fade the current one out, then fade the next one in (CSS handles the
    // 0.6s opacity transition).
    slides[oldIndex].classList.remove('active');
    setTimeout(() => {
      slides[newIndex].classList.add('active');
      currentIndex = newIndex;
    }, 600);
  };

  const startRotation = () => {
    stopRotation();
    // Only rotate when there's more than one message to cycle through.
    if (slides.length > 1) interval = setInterval(nextSlide, 5000);
  };

  const stopRotation = () => clearInterval(interval);

  const updateToggle = () => {
    if (toggleButton) toggleButton.classList.toggle('paused', !isPlaying);
  };

  const saveState = () =>
    localStorage.setItem('announcementBarState', isPlaying ? 'playing' : 'paused');

  const togglePlayPause = () => {
    isPlaying = !isPlaying;
    isPlaying ? startRotation() : stopRotation();
    updateToggle();
    saveState();
  };

  // Restore the saved play/pause preference (only relevant if the toggle
  // button is ever re-enabled).
  const saved = localStorage.getItem('announcementBarState');
  if (saved) isPlaying = saved === 'playing';
  updateToggle();

  if (toggleButton) toggleButton.addEventListener('click', togglePlayPause);

  // Pause while hovered so shoppers can finish reading a message.
  announcementBar.addEventListener('mouseenter', () => {
    if (isPlaying) stopRotation();
  });
  announcementBar.addEventListener('mouseleave', () => {
    if (isPlaying) startRotation();
  });

  if (isPlaying) startRotation();
});
